<!-- Mobile header -->
<div class="calendar-header">
    <!-- Mobile menu -->
    <button class="button button_icon-only calendar-header__calendar-menu-button button-back" (click)="openCalendarMenu()"></button>

    <div *ngIf="configDiary.switchViewPlan == 1" class="calendar-header__worker-selection-wrapper">
        <div class="calendar-header__worker-selection">
            <!-- Worker selection in 4 days and week modes -->
            <div *ngIf="view == 'week' || view == '4days'" class="worker-selection__worker-wrapper">
                <div class="worker-list" [ngClass]="{ 'worker-list_opened': isWorkerListOpened }">
                    <div class="worker-list__option" *ngFor="let item of myeResources" (click)="chooseWorker(item.value)">
                        <img class="worker-option__icon worker-icon" src="{{ getWorkerImage(item.imagePath) }}" />
                        <span class="worker-option__name">{{ item.text }}</span>
                    </div>
                </div>
                <div [ngClass]="{ 'worker-list__background': isWorkerListOpened }" (click)="toggleWorkerList()"></div>

                <div class="worker-button-wrapper">
                    <mbsc-button class="worker-button" [options]="options" (click)="toggleWorkerList()">
                        <img class="worker-option__icon worker-icon" src="{{ getWorkerImage(selectedWorkerImagePath) }}" />
                        <span class="worker-button__name">{{ selectedWorkerName }}</span>
                    </mbsc-button>
                </div>
            </div>
            <!-- Worker selection in 1 day mode -->
            <div *ngIf="view == 'day'" class="worker-selection__worker-wrapper">
                <div class="worker-button-wrapper worker-button-1day-wrapper">
                    <mbsc-button class="worker-button" [options]="options" (click)="openWorkerSelection()">
                        <span class="worker-button__name">מציג {{ selectedWorkersCount }} מטפלים</span>
                    </mbsc-button>
                    <i class="fa-regular fa-chevron-left"></i>
                </div>
            </div>
        </div>
    </div>

    <mbsc-segmented-group
        *ngIf="configDiary.switchViewPlan == 2"
        class="mode-section__select-wrapper mode-section__select-wrapper_alternative"
        [(ngModel)]="view"
        (change)="changeView()"
    >
        <mbsc-segmented [options]="options" class="select-wrapper__option mode-section-option option_1day" value="day">
            <span class="mode-section-option__icon"></span>
        </mbsc-segmented>

        <mbsc-segmented [options]="options" class="select-wrapper__option mode-section-option option_4days" value="4days">
            <span class="mode-section-option__icon"></span>
        </mbsc-segmented>

        <mbsc-segmented [options]="options" class="select-wrapper__option mode-section-option option_7days" value="week">
            <span class="mode-section-option__icon"></span>
        </mbsc-segmented>
    </mbsc-segmented-group>

    <app-sidebar></app-sidebar>
</div>

<!-- Mobile header background -->
<div
    [ngClass]="{
        'calendar-header-background_visible':
            isCalendarMenuOpened || isModeSelectOpened || isWorkerSelectionOpened || isDialogVisible || isWorkerListModalOpened
    }"
    class="calendar-header-background"
></div>
<mbsc-eventcalendar
    #calendar
    class="calendar"
    [options]="calendarOptions"
    [data]="getData()"
    [view]="calView"
    [invalid]="invalid"
    [resources]="mybResources"
    [ngClass]="{ calendar_resources_hidden: view == '4days' || view == 'week', calendar_alternative: configDiary.switchViewPlan == 2 }"
    [(selectedDate)]="selectedDate"
    [refDate]="refDate"
    (onSelectedDateChange)="onSelectedDateChange($event)"
    [headerTemplate]="headerTemplate"
    [resourceTemplate]="resourceTemplate"
    [dayTemplate]="dayTemplate"
    [scheduleEventTemplate]="eventTemplate"
    appLongPress
    (longPress)="handleLongPress($event)"
>
    <ng-template #headerTemplate>
        <!-- Desktop calendar header -->
        <div class="calendar__header calendar__header_desktop">
            <div class="calendar-header__section mode-section">
                <!-- Desktop mode selection -->
                <mbsc-segmented-group class="mode-section__select-wrapper" [(ngModel)]="view" (change)="changeView()">
                    <mbsc-segmented [options]="options" class="select-wrapper__option mode-section-option option_1day" value="day">
                        <span class="mode-section-option__icon"></span>
                        <span class="mode-section-option__text">יומי</span>
                    </mbsc-segmented>

                    <mbsc-segmented [options]="options" class="select-wrapper__option mode-section-option option_4days" value="4days">
                        <span class="mode-section-option__icon"></span>
                        <span class="mode-section-option__text">4 ימים</span>
                    </mbsc-segmented>

                    <mbsc-segmented [options]="options" class="select-wrapper__option mode-section-option option_7days" value="week">
                        <span class="mode-section-option__icon"></span>
                        <span class="mode-section-option__text">שבועי</span>
                    </mbsc-segmented>
                </mbsc-segmented-group>

                <!-- Worker selection in 4 days and week modes -->
                <div *ngIf="view == 'week' || view == '4days'" class="mode-section__worker-wrapper">
                    <div class="worker-list" [ngClass]="{ 'worker-list_opened': isWorkerListOpened }">
                        <div class="worker-list__option" *ngFor="let item of myeResources" (click)="chooseWorker(item.value)">
                            <img class="worker-icon" src="{{ getWorkerImage(item.imagePath) }}" />
                            <span class="worker-option__name">{{ item.text }}</span>
                        </div>
                    </div>
                    <div [ngClass]="{ 'worker-list__background': isWorkerListOpened }" (click)="toggleWorkerList()"></div>

                    <div class="worker-button-wrapper">
                        <mbsc-button class="worker-button" [options]="options" (click)="toggleWorkerList()">
                            <img class="worker-button__icon worker-icon" src="{{ getWorkerImage(selectedWorkerImagePath) }}" />
                            <span class="worker-button__name">{{ selectedWorkerName }}</span>
                        </mbsc-button>
                    </div>
                </div>
            </div>

            <!-- Desktop datepicker -->
            <div class="calendar-header__section navigation-section">
                <mbsc-calendar-today class="navigation-section__today-button" (click)="refreshDate()"></mbsc-calendar-today>

                <div class="navigation-section__day-seletion">
                    <mbsc-calendar-prev class="navigation-section__prev-button"></mbsc-calendar-prev>

                    <mbsc-datepicker
                        class="navigation-section__calendar"
                        [options]="view == 'week' ? datepickerWeekOptions : datepickerDayOptions"
                        [labels]="datepickerLabels"
                        [(ngModel)]="selectedDate"
                        [showOverlay]="false"
                        [touchUi]="true"
                        [buttons]="[nowButton]"
                        (onChange)="onDatepickerChange()"
                        display="anchored"
                        [calendarHeaderTemplate]="desktopDatepickerHeader"
                        #desktopDatepicker
                    >
                        <ng-template #desktopDatepickerHeader>
                            <div class="datepicker-header">
                                <mbsc-calendar-prev class="datepicker-header__element datepicker-header__prev"></mbsc-calendar-prev>
                                <mbsc-calendar-nav class="datepicker-header__element datepicker-header__nav"></mbsc-calendar-nav>
                                <mbsc-calendar-next class="datepicker-header__element datepicker-header__next"></mbsc-calendar-next>
                            </div>
                        </ng-template>
                    </mbsc-datepicker>
                    <mbsc-button *ngIf="view == 'week' || view == '4days'" class="custom-datepicker-input" [options]="options" variant="flat">
                        {{ rangeText }}
                    </mbsc-button>

                    <mbsc-button *ngIf="view == 'day'" class="custom-datepicker-input" [options]="options" variant="flat">
                        יום {{ formatDate("DDD", selectedDate) }} {{ formatDate("D MMM", selectedDate) }}
                    </mbsc-button>

                    <mbsc-calendar-next class="navigation-section__next-button"></mbsc-calendar-next>
                </div>
            </div>

            <!-- Desktop menu -->
            <div class="calendar-header__section buttons-wrapper-section">
                <button *ngFor="let item of items_2" class="buttons-wrapper-section__button button header-button {{ item.icon }}">
                    <span class="header-button__icon"></span>
                    <span class="header-button__text">{{ item.label }}</span>
                </button>

                <button
                    *ngIf="!configDiary.isISocket"
                    (click)="getFreshData()"
                    class="buttons-wrapper-section__button button header-button refresh-button"
                >
                    <i class="header-button__icon fa-regular fa-arrows-rotate"></i>
                    <span class="header-button__text">רענן</span>
                </button>
            </div>
        </div>

        <!-- Mobile calendar header -->
        <div
            class="calendar__header calendar__header_mobile"
            [ngClass]="{
                calendar__header_alternative: configDiary.switchViewPlan == 2,
                'calendar__header_no-refresh': configDiary.isISocket
            }"
        >
            <div *ngIf="!configDiary.isISocket" class="calendar-header__section refresh-section">
                <button (click)="getFreshData()" class="refresh-section__button button header-button refresh-button">
                    <i class="header-button__icon fa-regular fa-arrows-rotate"></i>
                </button>
            </div>

            <!-- Mobile datepicker -->
            <div class="calendar-header__section navigation-section">
                <mbsc-calendar-prev class="navigation-section__prev-button"></mbsc-calendar-prev>

                <div class="navigation-section__day-seletion">
                    <mbsc-datepicker
                        class="navigation-section__calendar"
                        [options]="view == 'week' ? datepickerWeekOptions : datepickerDayOptions"
                        [(ngModel)]="selectedDate"
                        [labels]="datepickerLabels"
                        [showOverlay]="false"
                        [touchUi]="true"
                        [buttons]="[nowButton]"
                        (onChange)="onDatepickerChange()"
                        display="anchored"
                        [calendarHeaderTemplate]="mobileDatepickerHeader"
                        #mobileDatepicker
                    >
                        <ng-template #mobileDatepickerHeader>
                            <div class="datepicker-header">
                                <div class="datepicker-header-section datepicker-header__close-button close-button" (click)="closeDatepicker()">
                                    <i class="fa-regular fa-xmark"></i>
                                </div>
                                <mbsc-calendar-prev class="datepicker-header__element datepicker-header__prev"></mbsc-calendar-prev>
                                <mbsc-calendar-nav class="datepicker-header__element datepicker-header__nav"></mbsc-calendar-nav>
                                <mbsc-calendar-next class="datepicker-header__element datepicker-header__next"></mbsc-calendar-next>
                            </div>
                        </ng-template>
                    </mbsc-datepicker>

                    <mbsc-button *ngIf="view == 'week' || view == '4days'" class="custom-datepicker-input" [options]="options" variant="flat">
                        {{ rangeText }}
                    </mbsc-button>

                    <mbsc-button *ngIf="view == 'day'" class="custom-datepicker-input" [options]="options" variant="flat">
                        יום {{ formatDate("DDD", selectedDate) }} {{ formatDate("D MMM", selectedDate) }}
                    </mbsc-button>
                </div>

                <mbsc-calendar-next class="navigation-section__next-button"></mbsc-calendar-next>
            </div>

            <!-- Mobile mode selection -->
            <div *ngIf="configDiary.switchViewPlan == 1" class="calendar-header__section mode-section">
                <button class="mode-section__button button mode-button" (click)="openModeSelectMenu()">
                    <i class="mode-button__icon mode-button__{{ modeSelectItems[modeSelectItemSelected].icon }}"></i>
                    <i class="fa-regular fa-chevron-down"></i>
                </button>
            </div>

            <div
                *ngIf="configDiary.switchViewPlan == 2"
                class="calendar-header__worker-selection-wrapper calendar-header__worker-selection-wrapper_alternative"
            >
                <div class="calendar-header__worker-selection">
                    <!-- Worker selection in 4 days and week modes -->
                    <div *ngIf="view == 'week' || view == '4days'" class="worker-selection__worker-wrapper">
                        <div class="worker-button-wrapper">
                            <mbsc-button class="worker-button" [options]="options" (click)="toggleWorkerListModal()">
                                <img class="worker-button__icon worker-icon" src="{{ getWorkerImage(selectedWorkerImagePath) }}" />
                                <span class="worker-button__name">{{ selectedWorkerName }}</span>
                            </mbsc-button>
                        </div>
                    </div>
                    <!-- Worker selection in 1 day mode -->
                    <div *ngIf="view == 'day'" class="worker-selection__worker-wrapper">
                        <div class="worker-button-wrapper worker-button-1day-wrapper">
                            <mbsc-button class="worker-button" [options]="options" (click)="openWorkerSelection()">
                                <span class="worker-button__icon"></span>
                                <span class="worker-button__name">{{ selectedWorkersCount }} מטפלים</span>
                            </mbsc-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <!-- Resources -->
    <ng-template #resourceTemplate let-resource>
        <div class="resource resource_desktop schedule-header__item" (click)="toggleMenu($event, menu, false, resource)">
            <img class="resource__image" src="{{ getWorkerImage(resource.imagePath) }}" />
            <span class="resource__name schedule-header__text">{{ resource.name }}</span>
            <span class="resource__chevron schedule-header__chevron"><i class="fa-solid fa-chevron-down"></i></span>
        </div>

        <div class="resource resource_mobile schedule-header__item" (click)="toggleMenu($event, menu, true, resource)">
            <img class="resource__image" src="{{ getWorkerImage(resource.imagePath) }}" />
            <div class="resource__info">
                <span class="resource__name schedule-header__text">{{ resource.name }}</span>
                <span class="resource__chevron schedule-header__chevron"><i class="fa-solid fa-chevron-down"></i></span>
            </div>
        </div>

        <p-menu #menu class="schedule-header__menu action-list" [model]="items_1" [popup]="true"></p-menu>
    </ng-template>

    <!-- Days -->
    <ng-template #dayTemplate let-day>
        <div class="day day_desktop schedule-header__item" (click)="toggleMenu($event, menu, false, day)">
            <span class="day__date schedule-header__text">{{ formatDate("יום DDD D MMMM", day.date) }}</span>
            <span class="day__chevron schedule-header__chevron"><i class="fa-solid fa-chevron-down"></i></span>
        </div>

        <div class="day day_mobile schedule-header__item" (click)="toggleMenu($event, menu, true, day)">
            <span class="day__date schedule-header__text">{{ formatDate("D", day.date) }}</span>
            <span class="day__info schedule-header__text">{{ formatDate("יום DDD", day.date) }}</span>
            <span class="day__chevron schedule-header__chevron"><i class="fa-solid fa-chevron-down"></i></span>
        </div>

        <p-menu #menu class="schedule-header__menu action-list" [model]="items_1" [popup]="true"></p-menu>
    </ng-template>

    <!-- Events -->
    <ng-template #eventTemplate let-event>
        <div *ngIf="!event.allDay" class="event" [ngStyle]="{ borderColor: event.original.color }">
            <div class="event__header">
                <div class="event__icons">
                    <span *ngIf="event.original.isExtAppId" class="event__icon event-icon">
                        <i class="fa-regular fa-mobile-screen-button"></i>
                    </span>

                    <span *ngIf="event.original.prepayStatus == 0" class="event__icon event-icon">
                        <img src="/assets/img/apppayed.svg" />
                    </span>

                    <span *ngIf="event.original.prepayStatus == 1" class="event__icon event-icon">
                        <img src="/assets/img/ppsend.svg" />
                    </span>

                    <span *ngIf="event.original.prepayStatus == 2" class="event__icon event-icon">
                        <img src="/assets/img/pppayed.svg" />
                    </span>

                    <span *ngIf="event.original.statusAppointment == 1" class="event__icon event-icon">
                        <i class="fa-regular fa-hourglass-clock"></i>
                    </span>

                    <span *ngIf="event.original.statusAppointment == 2" class="event__icon event-icon">
                        <i class="fa-regular fa-user-clock"></i>
                    </span>

                    <span *ngIf="event.original.statusAppointment == 3" class="event__icon event-icon">
                        <i class="fa-regular fa-thumbs-up"></i>
                    </span>

                    <span *ngIf="event.original.statusAppointment == 5" class="event__icon event-icon">
                        <i class="fa-regular fa-circle-check"></i>
                    </span>

                    <span *ngIf="event.original.hasComments" class="event__icon event-icon">
                        <i class="fa-regular fa-circle-exclamation"></i>
                    </span>

                    <span *ngIf="event.original.isBirthday" class="event__icon event-icon">
                        <i class="fa-solid fa-cake-candles"></i>
                    </span>

                    <span *ngIf="event.original.isCustIcon" class="event__icon event-icon">
                        <i class="fa-regular fa-user-plus"></i>
                    </span>

                    <span *ngIf="event.original.isRepeatAppointment" class="event__icon event-icon">
                        <i class="fa-regular fa-arrows-rotate"></i>
                    </span>
                </div>
                <span class="event__title">{{ event.title }}</span>
            </div>

            <div class="event__body">
                <span class="event__time">{{ event.start }}-{{ event.end }}</span>
                <span class="event__text">
                    <span *ngIf="event.original.resourceStream">{{ event.original.resourceStream }} | </span>
                    <span *ngIf="event.original.con">{{ event.original.con }} | </span>
                    {{ event.original.job }}
                </span>
            </div>

            <div class="event__background" [ngStyle]="{ background: event.original.color }"></div>
        </div>

        <div *ngIf="event.allDay" class="event_all-day">
            <span class="event_all-day__title">{{ event.original.holidayName }}</span>
        </div>
    </ng-template>
</mbsc-eventcalendar>

<!-- Calendar loader -->
<div *ngIf="state == 'loading'" class="loader">
    <span class="loader__spinner"></span>
</div>

<!-- Mobile mode selction modal -->
<p-dialog
    [ngClass]="{ 'custom-dialog': isModeSelectOpened }"
    styleClass="modal modal_type_menu modal_mode-select-menu"
    [(visible)]="isModeSelectOpened"
    header="מעבר בין יומנים"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
    transitionOptions="0ms"
>
    <button *ngFor="let item of modeSelectItems" class="menu-button option-{{ item.icon }} button button_with-icon" (click)="item.command()">
        {{ item.label }}
    </button>
</p-dialog>

<!-- Day menu modal -->
<p-dialog
    [ngClass]="{ 'custom-dialog': isCalendarHeaderMenuOpened }"
    styleClass="modal modal_type_menu modal_calendar-header-menu"
    [(visible)]="isCalendarHeaderMenuOpened"
    header="פעולות נוספות"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
    transitionOptions="0ms"
>
    <button
        *ngFor="let item of items_1"
        class="menu-button {{ item.icon }} button button_with-icon"
        (click)="item.command()"
        [disabled]="item.disabled"
    >
        {{ item.label }}
    </button>
</p-dialog>

<!-- Mobile menu modal -->
<p-dialog
    [ngClass]="{ 'custom-dialog': isCalendarMenuOpened }"
    styleClass="modal modal_type_menu modal_calendar-menu"
    [(visible)]="isCalendarMenuOpened"
    header="פעולות נוספות"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
    transitionOptions="0ms"
>
    <button
        *ngFor="let item of items_2"
        class="menu-button {{ item.icon }} button button_with-icon"
        (click)="item.command()"
        [disabled]="item.disabled"
    >
        {{ item.label }}
    </button>
</p-dialog>

<!-- Mobile worker selection modal in 1 day mode -->
<p-dialog
    [ngClass]="{ 'custom-dialog': isWorkerSelectionOpened }"
    styleClass="modal modal_type_worker-selection"
    [(visible)]="isWorkerSelectionOpened"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
    [showHeader]="false"
>
    <div class="modal__header modal-header">
        <span class="modal-header__name">בחירת מטפלים</span>

        <span class="modal-header__text">עד 7 מטפלים</span>

        <span class="modal-header__error" [ngClass]="{ 'modal-header__error_visible': isSelectedWorkersOverLimit }">
            לא ניתן לבחור יותר מ- 7 מטפלים בתצוגה
        </span>
    </div>

    <div class="modal__section">
        <div class="worker-multiple-list">
            <div *ngFor="let item of myeResources" class="worker-multiple-list__option worker-option">
                <img class="worker-option__icon worker-icon" src="{{ getWorkerImage(item.imagePath) }}" />

                <span class="worker-option__name">{{ item.text }}</span>

                <input class="checkbox" [(ngModel)]="item.isSelected" type="checkbox" (change)="chooseWorkerFromMultipleList()" />
                <span class="custom-checkbox"></span>
            </div>
        </div>
    </div>
    <div class="modal__footer">
        <button class="button button_size_small button_theme_gray-line" (click)="cancelButton()">בטל</button>
        <button
            class="button button_size_small button_theme_main"
            [disabled]="isNotSelectedWorkers || isSelectedWorkersOverLimit"
            (click)="saveWorkerSelection()"
        >
            שמירה
        </button>
    </div>
</p-dialog>

<!-- Info card popup -->
<mbsc-popup class="info-card-popup" [options]="infoCardPopupOptions" [anchor]="popupAnchor" [headerText]="popupHeaderText" #infoCardPopup>
    <div class="info-card-popup__client-image-wrapper">
        <img
            *ngIf="!infoCardPopupEvent.isOffDay"
            class="client-image-wrapper__client-image"
            [ngClass]="{ 'client-image_empty': !infoCardPopupIpath }"
            [src]="getClientImageSrc()"
            (error)="clearImagePath()"
            alt="Client picture"
        />
        <img
            *ngIf="infoCardPopupEvent.isOffDay && infoCardPopupOffTimeType == 1"
            class="client-image-wrapper__client-image"
            src="/assets/img/absence1.jpg"
            alt="Absence free"
        />
        <img
            *ngIf="infoCardPopupEvent.isOffDay && infoCardPopupOffTimeType == 2"
            class="client-image-wrapper__client-image"
            src="/assets/img/absence2.png"
            alt="Absence Pause"
        />
        <img
            *ngIf="infoCardPopupEvent.isOffDay && infoCardPopupOffTimeType == 3"
            class="client-image-wrapper__client-image"
            src="/assets/img/absence3.jpg"
            alt="Absence Personal"
        />

        <button class="client-image-wrapper__close-button close-button" (click)="closeInfoCardPopup()">
            <i class="fa-regular fa-xmark"></i>
        </button>

        <!-- <div *ngIf="infoCardPopupEvent.customerId < 0" class="client-image-wrapper__client-button new-client button button_size_small button_with-icon">
            <i class="fa-regular fa-user-plus"></i>
            הוסף לקוח/ה למאגר
        </div>

        <div *ngIf="infoCardPopupEvent.customerId >= 0" class="client-image-wrapper__client-button button button_size_small button_with-icon">
            <i class="fa-regular fa-user"></i>
            לכרטיס לקוח/ה
        </div> -->

        <div *ngIf="infoCardPopupEvent.customerId" class="client-image-wrapper__header-section">
            <div class="header-section__name-section">
                <span class="name-section__name">{{ infoCardPopupEvent.firstName }}</span>
                <span class="name-section__phone">{{ infoCardPopupEvent.phoneNum2 }}</span>
            </div>
            <div *ngIf="!infoCardPopupEvent.isOffDay" class="header-section__contacts-section">
                <a
                    class="contacts-section__button contacts-section__whatsapp button button_icon-only"
                    href="{{ getWhatsAppLink(infoCardPopupEvent.phoneNum2) }}"
                    target="_blank"
                >
                    <img src="assets/img/whatsapp.svg" alt="icon-whatsapp" />
                </a>

                <button
                    class="contacts-section__button contacts-section__message button button_icon-only"
                    (click)="openDialog(infoCardPopupEvent.customerId, infoCardPopupEvent.phoneNum2)"
                >
                    <img class="card__icon" src="/assets/img/chat-dots.svg" alt="chat-dots" />
                </button>

                <a class="contacts-section__button contacts-section__phone button button_icon-only" href="tel:{{ infoCardPopupEvent.phoneNum2 }}">
                    <i class="fa-solid fa-phone"></i>
                </a>
            </div>
        </div>
    </div>

    <div class="info-card-popup__body">
        <div
            *ngIf="
                !infoCardPopupEvent.isOffDay &&
                ((infoCardPopupEvent.customerId && (infoCardPopupEvent.debt || infoCardPopupIsBirthday)) || !infoCardPopupEvent.customerId)
            "
            class="body__tags-wrapper"
        >
            <div *ngIf="infoCardPopupEvent.customerId && infoCardPopupEvent.debt" class="tags-wrapper__tag debt-tag">
                <span class="tag__text">חוב: {{ infoCardPopupEvent.debt }} ₪</span>
                <i class="fa-duotone fa-coins"></i>
            </div>

            <div *ngIf="infoCardPopupEvent.customerId && infoCardPopupIsBirthday" class="tags-wrapper__tag birthday-tag">
                <span class="tag__text">יום הולדת: {{ infoCardPopupEvent.birthDay }}/{{ infoCardPopupEvent.birthMonth }}</span>
                <i class="fa-solid fa-cake-candles"></i>
            </div>

            <div *ngIf="!infoCardPopupEvent.customerId" class="tags-wrapper__tag new-client-tag">
                <span class="tag__text">לקוח/ה לא במאגר</span>
                <i class="fa-regular fa-user-plus"></i>
            </div>
        </div>

        <div class="body__section body__section-info">
            <span *ngIf="infoCardPopupEvent.customerId < 0" class="body__no-client-text">
                <i class="no-client-text__icon fa-solid fa-user-plus"></i>
                לקוח/ה לא במאגר
            </span>

            <div class="body__title">
                <span *ngIf="infoCardPopupEvent.isOffDay">{{ infoCardPopupEvent.firstName }}</span>
                <span *ngIf="!infoCardPopupEvent.isOffDay">פרטי התור</span>

                <div *ngIf="infoCardPopupEvent.holidayName" class="body__holiday">
                    {{ infoCardPopupEvent.holidayName }}
                </div>
            </div>

            <div class="body-section__card">
                <div class="section__event-time">
                    <div class="event-time__date event-time__item">
                        <span class="event-time-item__icon">
                            <i class="fa-regular fa-calendar-range"></i>
                        </span>

                        <span class="event-time-item__text_bold">
                            {{ infoCardPopupEvent.start | date : "EEE dd/MM" }}
                        </span>

                        <span class="event-time-item__text_default">
                            מטפל/ת:
                            <span class="event-time-item__text_bold">
                                {{ infoCardPopupEventResource }}
                            </span>
                        </span>
                    </div>

                    <div class="event-time__time event-time__item">
                        <span class="event-time-item__icon">
                            <i class="fa-regular fa-clock-nine"></i>
                        </span>

                        <span class="event-time-item__text_bold">
                            {{ infoCardPopupEvent.end | date : "HH:mm" }} - {{ infoCardPopupEvent.start | date : "HH:mm" }}
                        </span>

                        <span class="event-time-item__text_default"> {{ infoCardPopupEventDuration }} דקות </span>
                    </div>
                </div>

                <div class="section__event-services">
                    <span
                        *ngIf="!infoCardPopupEvent.isOffDay && (!infoCardPopupEvent.job || !infoCardPopupEvent.job.length)"
                        class="event-services__text event-services__text_empty"
                    >
                        לא נבחרו טיפולים
                    </span>

                    <div *ngIf="infoCardPopupEvent.job && infoCardPopupEvent.job.length">
                        <div *ngIf="infoCardPopupEvent.subexp && infoCardPopupEvent.subexp.length > 0">
                            <div *ngFor="let item of templstsub" class="event-services__service">
                                <span class="event-services__text">{{ item.servicename }}</span>
                                <span *ngIf="item.subT > 0" class="event-services__text event-services__text_subscription">
                                    <span class="subscription__icon"></span>
                                    {{ item.sub }}/{{ item.subT }}
                                </span>
                            </div>
                        </div>

                        <span *ngIf="!infoCardPopupEvent.subexp || infoCardPopupEvent.subexp.length == 0" class="event-services__text">
                            <span *ngFor="let job of infoCardPopupEventJobs">{{ job }}</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="infoCardPopupEvent.hasComments" class="body__section">
            <h3 *ngIf="!infoCardPopupEvent.offTimeType && infoCardPopupEvent.customerId" class="body__title">הערות לתור</h3>
            <h3 *ngIf="infoCardPopupEvent.offTimeType && infoCardPopupEvent.customerId" class="body__title">הערות לזמן אישי</h3>
            <h3 *ngIf="!infoCardPopupEvent.customerId" class="body__title">הערות</h3>

            <div class="body-section__card">{{ infoCardPopupComment }}</div>
        </div>

        <div *ngIf="infoCardPopupEvent.resourceStream && infoCardPopupEvent.resourceStream.length" class="body__section">
            <h3 class="body__title">משאבים</h3>

            <div class="body-section__card">{{ infoCardPopupEvent.resourceStream }}</div>
        </div>

        <div *ngIf="infoCardPopupEvent.con && infoCardPopupEvent.con.length" class="body__section">
            <h3 class="body__title">בעלי חיים</h3>

            <div class="body-section__card">{{ infoCardPopupEvent.con }}</div>
        </div>

        <div
            *ngIf="
                infoCardPopupEvent.isExtAppId ||
                infoCardPopupEvent.prepayStatus >= 0 ||
                (infoCardPopupEvent.statusAppointment > 0 && infoCardPopupEvent.statusAppointment != 4)
            "
            class="body__section"
        >
            <h3 class="body__title">פרטים נוספים</h3>

            <div class="body-section__card card-event-tags">
                <div class="section__event-tag" *ngIf="infoCardPopupEvent.isExtAppId">
                    <span class="event-tag__icon">
                        <i class="fa-regular fa-mobile-screen-button"></i>
                    </span>
                    <span class="event-tag__text">נקבע ע"י iTor</span>
                </div>

                <div class="section__event-tag" *ngIf="infoCardPopupEvent.prepayStatus == 0">
                    <span class="event-tag__icon">
                        <img src="/assets/img/apppayed.svg" />
                    </span>
                    <span class="event-tag__text">התור שולם</span>
                </div>
                <div class="section__event-tag" *ngIf="infoCardPopupEvent.prepayStatus == 1">
                    <span class="event-tag__icon">
                        <img src="/assets/img/ppsend.svg" />
                    </span>
                    <span class="event-tag__text">נשלחה בקשת לתשלום מקדמה</span>
                </div>
                <div class="section__event-tag" *ngIf="infoCardPopupEvent.prepayStatus == 2">
                    <span class="event-tag__icon">
                        <img src="/assets/img/pppayed.svg" />
                    </span>
                    <span class="event-tag__text">המקדמה שולמה ע"י הלקוח/ה</span>
                </div>

                <div class="section__event-tag" *ngIf="infoCardPopupEvent.statusAppointment == 1">
                    <span class="event-tag__icon">
                        <i class="fa-regular fa-hourglass-clock"></i>
                    </span>
                    <span class="event-tag__text">הלקוח/ה הגיע וממתין</span>
                </div>
                <div class="section__event-tag" *ngIf="infoCardPopupEvent.statusAppointment == 2">
                    <span class="event-tag__icon">
                        <i class="fa-regular fa-user-clock"></i>
                    </span>
                    <span class="event-tag__text">הלקוח/ה בעבודה</span>
                </div>
                <div class="section__event-tag" *ngIf="infoCardPopupEvent.statusAppointment == 3">
                    <span class="event-tag__icon">
                        <i class="fa-regular fa-thumbs-up"></i>
                    </span>
                    <span class="event-tag__text">הלקוח/ה סיים</span>
                </div>
                <div class="section__event-tag" *ngIf="infoCardPopupEvent.statusAppointment == 5">
                    <span class="event-tag__icon">
                        <i class="fa-regular fa-circle-check"></i>
                    </span>
                    <span class="event-tag__text">הלקוח אישר הגעה</span>
                </div>
            </div>
        </div>
    </div>
</mbsc-popup>

<!-- Event creating popup -->
<mbsc-popup class="new-event-popup" [anchor]="popupAnchor" [options]="popupNewEventOptions" #newEventPopup>
    <button class="close-button" (click)="closeNewEventPopup()">
        <i class="fa-regular fa-xmark"></i>
    </button>

    <app-create-appointment
        [config]="config"
        [configDiary]="configDiary"
        [appDataTemp]="newAppData"
        [resources]="myeResources"
        [holidayName]="newAppDataHoliday"
        [invalid]="newCardPopupEventInvalidTime"
        [isEditingEvent]="isEditingEvent"
        (newItemAppointment)="addItem($event)"
    ></app-create-appointment>
</mbsc-popup>

<!-- Sending SMS popup -->
<p-dialog class="dialog__panel" [(visible)]="isDialogVisible" [resizable]="false" [draggable]="false" [modal]="true" [dismissableMask]="true">
    <h3 class="dialog__title">שליחת סמס ללקוח</h3>

    <div class="input-wrapper" [ngClass]="{ 'input-wrapper_with-details': isDialogErrorVisible, 'input-wrapper_error': isDialogErrorVisible }">
        <input class="input" #smsInput [(ngModel)]="smsText" type="text" autocomplete="off" />
        <span class="input-details">השדה הזה לא יכול להיות ריק</span>
    </div>

    <div class="dialog__buttons">
        <button class="button button_size_small button_theme_main" (click)="hideDialog(true)">לשלוח</button>
        <button class="button button_size_small button_theme_gray-line" (click)="hideDialog(false)">ביטול</button>
    </div>
</p-dialog>

<!-- Calendar menu -->
<mbsc-select
    #menuright
    class="event-popup-menu"
    [(ngModel)]="selectValue"
    [data]="menuData"
    [anchor]="menuAnchor"
    [options]="menuSettings"
    [itemTemplate]="itemTemp"
    [itemHeight]="isMobileMenu ? '50' : '34'"
>
    <ng-template #itemTemp let-item>
        <div class="event-popup-menu__item event-menu-item {{ item.data.class }}">
            <span class="event-menu-item__icon"></span>
            <span class="event-menu-item__text">{{ item.data.text }}</span>
        </div>
    </ng-template>
</mbsc-select>

<!-- Event deleting popup -->
<mbsc-popup class="answer-popup" [options]="popupOptions" [anchor]="menuAnchor" [buttons]="popupButtons" #popupanswer>
    <div class="answer-popup__header answer-popup-header">
        <button class="answer-popup-header__cross-icon" (click)="closeAnswerPopup()">
            <i class="fa-solid fa-xmark"></i>
        </button>
        <span class="answer-popup-header__text">{{ answerPopupHeaderText }}</span>
    </div>

    <div *ngIf="!clickDel" class="answer-popup__status-upgrade answer-popup__settings">
        <span class="setting__text">{{ statusUpgradeEventText }}</span>
        <button class="button button_theme_main button_size_small" (click)="closeAnswerPopup()">סגירה</button>
    </div>

    <div *ngIf="clickDel && !isAbsenceEvent" class="answer-popup__delete answer-popup__settings">
        <span *ngIf="isManyEvCustomer" class="setting__text">בחרו סיבת ביטול ואילו תורים למחוק</span>
        <span *ngIf="!isManyEvCustomer" class="setting__text">בחרו סיבת ביטול לתור</span>

        <div class="settings__reason-select input-wrapper input-wrapper_type_select input-wrapper_with-icon">
            <select class="input dropdown__input" [(ngModel)]="reasonCancellationEv">
                <option *ngFor="let reason of absenceData">
                    {{ reason.text }}
                </option>
            </select>
        </div>

        <div *ngIf="isManyEvCustomer">
            <label class="switch-label switch-label_size_small">
                למחוק תורים נוספים באותו יום
                <input class="switch" [(ngModel)]="isRemovingAdditionalApp" type="checkbox" />
                <span class="custom-switch"></span>
            </label>
        </div>

        <button class="button button_size_small button_theme_main" (click)="confirmDeleteApp()">המשך</button>
    </div>

    <div *ngIf="clickDel && isAbsenceEvent" class="answer-popup__delete answer-popup__settings">
        <!-- <p>מחיקת זמן אישי</p> -->
        <span class="setting__text setting__text_absence">שימו לב שאתם עומדים למחוק זמן אישי / חופש של המטפל/ת</span>

        <button class="button button_size_small button_theme_main" (click)="confirmDeleteApp()">המשך</button>
    </div>
</mbsc-popup>

<!-- Delete confirmation popup -->
<p-dialog
    [ngClass]="{ 'custom-dialog': isAnswerConfirmPopupVisible }"
    styleClass="modal modal_type_confirm"
    [(visible)]="isAnswerConfirmPopupVisible"
    header="שימו לב"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
>
    <span *ngIf="isAbsenceEvent" class="modal__text">אנא אשרו את המחיקה</span>
    <span *ngIf="!isAbsenceEvent" class="modal__text">אנא אשרו את מחיקת התור</span>
    <div class="modal__footer">
        <button class="button button_size_small button_theme_main" (click)="confirmDeleteEvent()">מחיקה</button>
        <button class="button button_size_small button_theme_gray-line" (click)="cancelDeleteEventConfirmation()">ביטול</button>
    </div>
</p-dialog>

<!-- Mobile menu modal -->
<p-dialog
    [ngClass]="{ 'custom-dialog': isWorkerListModalOpened && configDiary.switchViewPlan == 2 }"
    styleClass="modal modal_type_menu modal_worker-list-menu"
    [(visible)]="isWorkerListModalOpened"
    header="בחירת מטפל"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
    transitionOptions="0ms"
>
    <div class="worker-list__option" *ngFor="let item of myeResources" (click)="chooseWorker(item.value)">
        <img class="worker-option__icon worker-icon" src="{{ getWorkerImage(item.imagePath) }}" />
        <span class="worker-option__name">{{ item.text }}</span>
    </div>
</p-dialog>

<p-messages class="messages"></p-messages>
